// hooks
import { useCallback, useEffect, useState, Fragment } from "react";
import useHttp from "hooks/use-http";
import { useNavigate } from "react-router-dom";

// material styles
import { Grid, Tooltip } from "@mui/material";

// material icons
import { Email, Drafts } from "@mui/icons-material";

// components
import LoadingCM from "components/shared/Loading";
import DrawerCM from "components/shared/Drawer";
import TableCM from "components/shared/Table";
import PaginationCM from "components/shared/Pagination";

// helper
import GenerateHeadCell from "helper/generate-head-cell";

// constants
import { PAGINATION_LIMIT } from "constants";

// request methods
import { getAllCatalogsDataRequest } from "api/requests/catalogs";

// catalogs head cells
const headCells = GenerateHeadCell("catalogs_list");

function DisplayCatalogs() {
  const { request, loading, setLoading } = useHttp(false);

  const navigate = useNavigate();

  // states for filtered
  const [searchValue, setSearchValue] = useState("");

  // catalogs data state
  const [catalogsData, setCatalogsData] = useState({
    data: [],
    count: 0,
  });

  // page state for pagination
  const [page, setPage] = useState(1);

  const handleSearch = (e) => setSearchValue(e);

  // get all catalogs data
  const getCatalogsData = useCallback(async () => {
    setLoading(true);

    const res = await request({
      url: getAllCatalogsDataRequest,
      values: {
        skip: searchValue ? 0 : (page - 1) * PAGINATION_LIMIT,
        limit: searchValue ? 100 : PAGINATION_LIMIT,
        search: searchValue || null,
      },
      isMulty: true,
    });

    setLoading(false);
    if (res) {
      if (res.data.count < 1) {
        return setCatalogsData({
          count: res.data.count,
          data: [{ content: "هیچ اطلاعاتی یافت نشد" }],
        });
      }

      let transformedData = res.data.data.map((items) => ({
        id: items.id,
        tracking_code: items.id,
        full_name: items.user.full_name,
        phone_number: items.user.phone_number,
        company: items.company_name,
        type: items.post,
        email: items.user.email,
        is_seen: items.is_seen ? (
          <Tooltip title="مشاهده شده" placement="top">
            <Drafts color="success" />
          </Tooltip>
        ) : (
          <Tooltip title="مشاهده نشده" placement="top">
            <Email color="primary" />
          </Tooltip>
        ),
      }));

      setCatalogsData({
        data: transformedData,
        count: res.data.count,
      });
    }
    setLoading(false);
  }, [page, searchValue]);

  useEffect(() => {
    getCatalogsData();
  }, [getCatalogsData]);
  return (
    <DrawerCM title="کاتالوگ ها" onSearch={handleSearch}>
      {loading ? (
        <LoadingCM />
      ) : (
        <Fragment>
          <Grid container>
            <Grid item xs={12} my={2}>
              <TableCM
                title="لیست کاتالوگ ها"
                rows={catalogsData.data}
                headCells={headCells}
                click={(catalog_id) => navigate("/catalogs/" + catalog_id)}
                page={page}
                colspan={catalogsData.count === 0 ? "11" : ""}
                fontSize="12px"
                cellFontSize="12px"
              />
            </Grid>
            {catalogsData.count < 1 ? (
              ""
            ) : (
              <PaginationCM
                handleChange={(_, val) => setPage(val)}
                page={page}
                count={catalogsData.count}
              />
            )}
          </Grid>
        </Fragment>
      )}
    </DrawerCM>
  );
}

export default DisplayCatalogs;
